<template>
  <div
    :class="{
      select_boxes: !scrollable,
      'select_boxes--scrollable': scrollable
    }"
  >
    <SelectBox
      v-for="item in items"
      :key="item.name"
      :ref="item.value"
      :is-out-of-stock="item.is_out_of_stock"
      :label="item.name"
      :value="item.value"
      :is-selected="item.value === selectedValue"
      @input="selectRadioBtn"
    />
  </div>
</template>

<script>
import SelectBox from '../../atoms/select_boxes/SelectBox'
export default {
  components: { SelectBox },
  props: {
    itemsName: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: Number,
      required: false,
      default: 1
    },
    scrollable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$emit('mount')
    })
  },
  methods: {
    selectRadioBtn(value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss" scoped>
// select box
.select_boxes {
  display: flex;
  overflow: visible;

  &--scrollable {
    @extend .select_boxes;
    @extend %custom-scrollbar;
    overflow-x: auto;
  }
}
</style>
